import { Component } from '@angular/core';

@Component({
  selector: 'dram-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {

}
